'use client';

import AutoHeight from 'embla-carousel-auto-height';
import Fade from 'embla-carousel-fade';
import useEmblaCarousel from 'embla-carousel-react';
import { FC } from 'react';
import Button from '~/components/button';
import EmblaSlider from '~/components/embla-slider';
import EmblaContainer from '~/components/embla-slider/container';
import EmblaSlide from '~/components/embla-slider/slide';
import Heading from '~/components/heading';
import IBlockCompletedProjects from '~/data/strapi/types/shared-blocks/block-completed-projects';
import TitleTag from '~/enums/title-tag';

import ProjectDescription from './description';
import ProjectHeading from './heading';
import CompletedProjectsPattern from './pattern';
import styles from './styles.module.css';

interface Props {
  data: IBlockCompletedProjects;
  hideTypes?: boolean;
}

const BlockCompletedProjects: FC<Props> = ({ data, hideTypes }) => {
  const heading = data.heading;
  const projects = data.projects;
  const buttonData = data.button;

  const [ref, carousel] = useEmblaCarousel({ loop: true }, [Fade(), AutoHeight()]);

  const nextSlide = () => {
    carousel?.scrollNext();
  };

  const prevSlide = () => {
    carousel?.scrollPrev();
  };

  return (
    <article className={styles.container}>
      {heading && <Heading data={heading} className={styles.pagePadding} styleAs={TitleTag.H2} />}
      {projects && (
        <div>
          <EmblaSlider ref={ref} className={styles.slider}>
            <EmblaContainer className={styles.sliderContainer}>
              {projects.map((project) => (
                <EmblaSlide key={project.id} className={styles.slide}>
                  <ProjectHeading project={project} hideTypes={hideTypes} />
                  <ProjectDescription
                    project={project}
                    onNext={nextSlide}
                    onPrev={prevSlide}
                    hideNavigation={projects.length === 1}
                  />
                </EmblaSlide>
              ))}
            </EmblaContainer>
          </EmblaSlider>
        </div>
      )}
      {buttonData && <Button data={buttonData} className={styles.btn} />}

      <CompletedProjectsPattern />
    </article>
  );
};

export default BlockCompletedProjects;
